import { ECMCertificate } from '~/adapters/services/accounts/taxExemptionsECM/types';
import { Box, Stack, Tooltip } from '@customink/pigment-react';
import { UpperCaseChip } from '~/components/Chip/UpperCaseChip';
import { Circle } from '@mui/icons-material';
import { useStatusAdornments } from '~/pages/Settings/tabs/TaxExemptionECM/components/Certificate/statusTranslate';

interface CertificateListProps {
    certificates: Array<ECMCertificate>;
}

function Certificate({ certificate }: { certificate: ECMCertificate }) {
    const statusAdornment = useStatusAdornments(certificate);
    return (
        <Stack
            sx={{
                border: 1,
                borderRadius: 1,
                borderColor: 'divider',
                px: 2,
                py: 2,
                mb: 2,
            }}
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
        >
            <Stack flexWrap="wrap" flexDirection="row" justifyContent="flex-start" alignItems="center">
                <Box pr={4}>Certificate</Box>
                <Box pr={1}>{certificate.exposureZoneRegion}</Box>
                <Tooltip placement="right" title={statusAdornment.tooltipMessage ?? ''}>
                    <Box>
                        <UpperCaseChip
                            icon={<Circle width="50px" style={{ color: statusAdornment.color }} />}
                            label={certificate.cinkStatus}
                        />
                    </Box>
                </Tooltip>
            </Stack>
        </Stack>
    );
}

export function CertificateList({ certificates }: CertificateListProps) {
    return (
        <>
            {certificates.map((certificate) => (
                <Certificate key={certificate.id} certificate={certificate} />
            ))}
        </>
    );
}
